import {apiClient, FetcherSettings} from './apiClient';
import {Housing, HousingLocation, CheckoutSettings} from '../utils/types';
import {dynamicRoute} from './utils';

class HousingApi {
  ENDPOINTS = {
    getOne: dynamicRoute({
      regular: (id = '') => `api/v4/housings/${id}/`,
      sdk: (id = '') => `sdk/api/v2/housings/${id}/`,
    }),
    checkoutSetting: (id = '') => `api/v3/housing-check-out-settings/${id}`,
  };

  async getOne(id: string, fetcherSettings?: FetcherSettings) {
    const response = await apiClient.get<Housing>(
      this.ENDPOINTS.getOne(id),
      fetcherSettings,
    );
    return response.body;
  }

  async getCheckoutSetting(id: string, fetcherSettings?: FetcherSettings) {
    const response = await apiClient.get<CheckoutSettings>(
      this.ENDPOINTS.checkoutSetting(id),
      fetcherSettings,
    );
    return response.body;
  }

  // TODO check the access
  async getLocation(fetcherSettings?: FetcherSettings) {
    const response = await apiClient.get<HousingLocation>('', fetcherSettings);
    return response.body;
  }
}

export {HousingApi};
